/* --------------------
smooth scroll
-------------------- */
namespace GundockScroll {
  /**
   * ページ内リンクのスムーススクロールを初期化
   */
  export function initializeSmoothScroll(): void {
    // ページ内リンクを全て取得
    const pageLinks = document.querySelectorAll('a[href^="#"]');

    // 各リンクにイベントリスナーを追加
    pageLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();

        // リンク先の要素IDを取得
        const targetId = link.getAttribute('href');

        // #のみの場合はトップへスクロール
        if (targetId === '#') {
          gsap.to(window, {
            duration: 1,
            scrollTo: 0,
            ease: 'power2.inOut'
          });
          return;
        }

        // ターゲット要素を取得
        const targetElement = document.querySelector(targetId);

        if (targetElement) {
          // ターゲット要素へスクロール
          gsap.to(window, {
            duration: 1,
            scrollTo: {
              y: targetElement,
              offsetY: 80 // ヘッダーの高さなどのオフセット
            },
            ease: 'power2.inOut'
          });
        }

        // タブの切り替え処理
        if (targetId === '#anker3') {
          const tab2 = document.querySelector('.tab2') as HTMLElement;
          if (tab2) {
            tab2.click();
          }
        } else if (targetId === '#anker2' || targetId === '#anker1') {
          const tab1 = document.querySelector('.tab1') as HTMLElement;
          if (tab1) {
            tab1.click();
          }
        }
      });
    });
  }

  /**
   * スクロールアニメーションの初期化
   */
  export function initializeScrollAnimations(): void {
    // ScrollTriggerプラグインが利用可能か確認
    if (typeof gsap !== 'undefined' && gsap.registerPlugin && typeof ScrollTrigger !== 'undefined') {
      gsap.registerPlugin(ScrollTrigger);

      // 予約ボタンのアニメーション設定
      const reservationBtns = document.querySelectorAll('.btn-scr');

      if (reservationBtns.length > 0) {
        // ページ全体のスクロール位置を監視
        ScrollTrigger.create({
          // bodyまたはhtml要素をトリガーとして使用
          trigger: 'body',
          // スクロール開始位置を設定（ページ上部から100px）
          start: "top -100px",
          // 固定位置で常に監視
          endTrigger: 'body',
          end: "bottom top",
          onEnter: () => {
            // 100pxスクロールしたとき
            reservationBtns.forEach(btn => {
              btn.classList.add('active');
            });
          },
          onLeaveBack: () => {
            // 100px未満に戻ったとき
            reservationBtns.forEach(btn => {
              btn.classList.remove('active');
            });
          },
          markers: false // デバッグ時にはtrueにすると便利
        });
      }
    } else {
      console.warn('GSAPまたはScrollTriggerが読み込まれていません');
    }
  }
}

/**
 * #mvの高さがブラウザの高さ以上になったときにbodyに.mvvhを付ける
 */
const checkMvHeight = () => {
  if (window.innerWidth <= 768) {
    document.body.classList.remove('mvvh');
    return;
  }
  const mv = document.getElementById('mv') as HTMLElement;
  if (!mv) return;

  if (mv.offsetHeight >= window.innerHeight) {
    document.body.classList.add('mvvh');
  } else {
    document.body.classList.remove('mvvh');
  }
};

// DOMContentLoadedイベントリスナー
document.addEventListener('DOMContentLoaded', () => {
  GundockScroll.initializeSmoothScroll();
  GundockScroll.initializeScrollAnimations(); // 新しく追加

  checkMvHeight();

  // Characters Swiper
  const charactersSwiper = new Swiper('.characters-swiper', {
    spaceBetween: 72,
    centeredSlides: true,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 16,
      },
      769: {
        slidesPerView: 'auto',
      },
    },
  });

  // World Swiper
  const worldSwiper = new Swiper('.world-swiper', {
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.world-swiper .swiper-pagination',
      clickable: true,
    },
    resizeObserver: true,
    updateOnWindowResize: true,
    observer: true,
    observeParents: true,
  });

    // General Swiper
  document.querySelectorAll('.general-swiper-wrap, .system-swiper').forEach((container) => {
    const mainSwiperEl = container.querySelector('.general-swiper') as HTMLElement;
    const subSwiperEl = container.querySelector('.general-sub-swiper') as HTMLElement;
    const paginationEl = container.querySelector('.general-sub-swiper .swiper-pagination') as HTMLElement;
    const nextEl = container.querySelector('.swiper-button-next') as HTMLElement;
    const prevEl = container.querySelector('.swiper-button-prev') as HTMLElement;

    if (!mainSwiperEl || !subSwiperEl) {
      return;
    }

    // スライド内の画像の属性をテキスト要素に同期する関数
    const syncAltText = (swiperInstance: any) => {
      // containerが .memory-wrap 内にある場合のみ実行
      const parentWrap = container.closest('.memory-wrap');
      if (!parentWrap) return;

      const title = parentWrap.querySelector('h3');
      const memoryText = parentWrap.querySelector('.memory-text');
      // 現在アクティブなスライド要素を取得（loop: true の場合も activeIndex で取得可能）
      const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
      const img = activeSlide ? activeSlide.querySelector('img') : null;

      if (img) {
        const altText = img.getAttribute('alt');
        if (title && altText) {
          title.innerHTML = altText;
        }

        const mText = img.getAttribute('memory-text');
        if (memoryText && mText) {
          memoryText.innerHTML = mText;
        }
      }
    };

    const generalSubSwiper = new Swiper(subSwiperEl, {
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      loop: true,
      pagination: {
        el: paginationEl,
        clickable: true,
      },
    });

    const generalSwiper = new Swiper(mainSwiperEl, {
      loop: true,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      autoplay: {
        delay: 5000,
        speed: 1500,
        disableOnInteraction: false,
      },
      // スライド変更時と初期化時にaltテキストを同期
      on: {
        init: function () {
          syncAltText(this);
        },
        slideChange: function () {
          syncAltText(this);
        },
      },
    });

    if (generalSwiper.controller && generalSubSwiper.controller) {
      generalSwiper.controller.control = generalSubSwiper;
      generalSubSwiper.controller.control = generalSwiper;
    }
  });


  // リサイズ処理の最適化
  let resizeTimeout: any | null = null;
  window.addEventListener('resize', () => {
    if (resizeTimeout) {
      clearTimeout(resizeTimeout);
    }
    resizeTimeout = setTimeout(() => {
      if (worldSwiper) {
        worldSwiper.update();
      }
      checkMvHeight();
    }, 200);
  });
});


document.addEventListener('DOMContentLoaded', () => {
  const video = document.getElementById('holobook-video') as HTMLVideoElement;

  if (video) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            video.play().catch(error => {
              console.error('Video play failed:', error);
            });
          } else {
            video.pause();
          }
        });
      },
      {
        threshold: 0.5, // 要素が50%表示されたらコールバックを実行
      }
    );

    observer.observe(video);
  }


  /*modal*/
  const bgVideos = document.querySelectorAll<HTMLVideoElement>('.js-bg-video');
  const youtubeContainer = document.querySelector<HTMLElement>('#top_Modal .youtube');
  const topModal = document.getElementById('top_Modal');
  const movieModals = document.querySelectorAll<HTMLElement>('.movie-modal');
  const closeModalElements = document.querySelectorAll('.top_modal .top_modal-bg, .top_modal .top_modal-close');

  if (youtubeContainer && topModal) {
    // .movie-modalクリックでモーダルを表示
    movieModals.forEach(modal => {
      modal.addEventListener('click', (e) => {
        e.preventDefault();
        const videoId = modal.dataset.videoId;
        if (!videoId) return;

        // 背景動画を一時停止
        bgVideos.forEach(function (video) {
          video.pause();
        });

        // YouTube iframeを生成して自動再生
        const iframe = '<iframe src="https://www.youtube.com/embed/' + videoId + '?autoplay=1&mute=0&playsinline=1&loop=1&playlist=' + videoId + '" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
        youtubeContainer.innerHTML = iframe;
        topModal.style.display = 'block';
        document.documentElement.classList.add('modalset');
      });
    });

    // 閉じるボタンのクリックイベント
    closeModalElements.forEach(closeElement => {
      closeElement.addEventListener('click', function () {
        // iframeを削除して動画を停止
        youtubeContainer.innerHTML = '';
        topModal.style.display = 'none';
        // 背景動画を再生
        bgVideos.forEach(function (video) {
          video.play();
        });
        document.documentElement.classList.remove('modalset');
      });
    });
  }

  /*
Tab
--------------------------------------------------*/
  const initializeTabs = () => {
    const tabs = document.querySelectorAll('.tab > li');
    const tabBodies = document.querySelectorAll('[class^="tab-body"]');

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        // Remove active class from all tabs and tab bodies
        tabs.forEach(t => t.classList.remove('active'));
        tabBodies.forEach(body => body.classList.remove('active'));

        // Add active class to the clicked tab
        tab.classList.add('active');

        // Get the class name of the clicked tab (e.g., "tab1")
        const tabClassName = Array.from(tab.classList).find(c => c.startsWith('tab') && c !== 'tab');

        if (tabClassName) {
          // Find the corresponding tab body and add the active class
          const tabBodyNumber = tabClassName.replace('tab', '');
          const correspondingBody = document.querySelector(`.tab-body${tabBodyNumber}`);
          if (correspondingBody) {
            correspondingBody.classList.add('active');
          }
        }
      });
    });
  };

  initializeTabs();
});


//動画再生
document.addEventListener('DOMContentLoaded', () => {
  const video = document.getElementById('video') as HTMLVideoElement;

  if (video) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            video.play().catch(error => {
              console.error('Video play failed:', error);
            });
          } else {
            video.pause();
          }
        });
      },
      {
        threshold: 0.5, // 要素が50%表示されたらコールバックを実行
      }
    );

    observer.observe(video);
  }
});